import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["region"]
  static values = { regions: Object }

  update(event) {
    const country = event.target.value
    const regions = this.regionsValue[country] || {}
    const select = this.regionTarget
    const previousValue = select.value

    select.innerHTML = ""
    Object.entries(regions).forEach(([code, label]) => {
      const option = document.createElement("option")
      option.value = code
      option.textContent = label
      select.appendChild(option)
    })

    if (regions[previousValue]) {
      select.value = previousValue
    } else if (regions[country]) {
      select.value = country
    } else {
      select.selectedIndex = 0
    }

    // The region select is wrapped by the `select` controller (SlimSelect); re-sync
    // it so the rebuilt options are reflected in the searchable list.
    const ctrl = this.application.getControllerForElementAndIdentifier(select, "select")
    if (ctrl) ctrl.refresh()
  }
}
